module.exports = __webpack_public_path__ + "media/images/skype-85f0aef3f504a193a17d679561db088b.svg";